import { render, staticRenderFns } from "./ListPPPage.vue?vue&type=template&id=26ed0ea1&"
import script from "./ListPPPage.vue?vue&type=script&lang=js&"
export * from "./ListPPPage.vue?vue&type=script&lang=js&"
import style0 from "./ListPPPage.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports